import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../../services/data.service";
import {RouterLink} from "@angular/router";
import {NgIf} from "@angular/common";
import {PaginationComponent} from "ngx-bootstrap/pagination";
import {FormsModule} from "@angular/forms";
import {YesNoPipe} from "../../pipes/yes-no.pipe";

@Component({
    selector: 'app-contact-list',
    imports: [RouterLink, NgIf, PaginationComponent, FormsModule, YesNoPipe],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-id-card me-2"></i>Kontakte <small class="text-muted">({{totalEntries}})</small></h3>
                </div>

                <button type="button" class="btn btn-primary mb-3" [routerLink]="['/contact', 0]">Kontakt anlegen</button>

                <pagination
                    [hidden]="entries?.length == 0"
                    [totalItems]="totalEntries"
                    [itemsPerPage]="paginConfig.itemsPerPage"
                    [(ngModel)]="paginConfig.page"
                    (pageChanged)="listEntries($event)"
                    [maxSize]="20"
                    previousText="Letzte"
                    nextText="Nächste">
                </pagination>

                <div class="table-responsive">
                    <table *ngIf="entries?.length > 0" class="table table-striped table-hover mb-0 pointer">
                        <thead>
                        <tr>
                            <th (click)="setOrder('category')">
                                Kategorie <i class="fa-solid" *ngIf="predicate == 'category'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('description')">
                                Bezeichnung <i class="fa-solid" *ngIf="predicate == 'description'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('name')">
                                Name <i class="fa-solid" *ngIf="predicate == 'name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('email')">
                                E-Mail <i class="fa-solid" *ngIf="predicate == 'email'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('phone')">
                                Telefon <i class="fa-solid" *ngIf="predicate == 'phone'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('website')">
                                Webseite <i class="fa-solid" *ngIf="predicate == 'website'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('visible_fn')">
                                Sichtbar FN <i class="fa-solid" *ngIf="predicate == 'visible_fn'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('visible_employee')">
                                Sichtbar Mitarbeiter <i class="fa-solid" *ngIf="predicate == 'visible_employee'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        @for (entry of entries; track entry.id) {
                            <tr [routerLink]="['/contact', entry.id]">
                                <td>{{ entry.category }}</td>
                                <td>{{ entry.description }}</td>
                                <td>{{ entry.name }}</td>
                                <td>{{ entry.email }}</td>
                                <td>{{ entry.phone }}</td>
                                <td>{{ entry.website }}</td>
                                <td>{{ entry.visible_fn | yesNo }}</td>
                                <td>{{ entry.visible_employee | yesNo }}</td>
                            </tr>
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `
})
export class ContactListComponent implements OnInit {

    private dataService = inject(DataService);

    paginConfig: any = {
        itemsPerPage: 25,
        page: 1
    };
    entries!: any[]|null;
    totalEntries = 0;
    predicate = 'name';
    search: any = {
        text: ''
    };
    reverse = false;

    ngOnInit(): void {
        this.listEntries(this.paginConfig);
    }

    setOrder(order: any): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event: any): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('Contact/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            filter: this.search.text,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.contacts;

            this.entries.forEach(entry => {
                entry.visible_fn = entry.visible_fn == 1;
                entry.visible_employee = entry.visible_employee == 1;
            })
        });
    }

}
